<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Submit Record</p>
      <button @click="cancel" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section class="modal-card-body padding-bottom82">
      <p :class="$style.modalContent">
        Once you submit this record, please select how you wish to continue:
      </p>
      <div :class="$style.radioWrapper">
        <b-radio
          v-model="isSubmitAnotherRecord"
          name="name"
          :class="$style.selectionRadio"
          :native-value="true"
        >
          Stay and submit new record
        </b-radio>
      </div>
      <div :class="$style.radioWrapper">
        <b-radio
          v-model="isSubmitAnotherRecord"
          name="name"
          :class="$style.selectionRadio"
          :native-value="false"
        >
          Go back to {{ isDataCollector ? 'Project Details' : 'Overview' }}
        </b-radio>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button
        class="button is-primary bg-white"
        :disabled="isSubmitAnotherRecord === null"
        :class="$style.continueButton"
        @click="confirmContinue"
      >
        Continue
      </button>
      <button class="button is-primary is-rounded" @click="cancel">
        Cancel
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SubmitNewRecordModal extends Vue {
  @Prop(Boolean) public isDataCollector!: boolean;
  public isSubmitAnotherRecord: boolean | null = null;

  public confirmContinue(): void {
    this.$emit('confirm', this.isSubmitAnotherRecord);
    this.$emit('close');
  }
  public cancel(): void {
    this.$emit('close');
  }
}
</script>
<style lang="scss" module>
.modalContent {
  margin-bottom: 12px;
}
.continueButton {
  color: $primary !important;
}
.selectionRadio {
  margin: 16px 0 0 0;
  &:global(.b-radio.radio input[type='radio'] + .check) {
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
